/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Cancel_Reason_Just_TryingInputs */

const en_settings_cancel_reason_just_trying = /** @type {(inputs: Settings_Cancel_Reason_Just_TryingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Just wanted to try it`)
};

const id_settings_cancel_reason_just_trying = /** @type {(inputs: Settings_Cancel_Reason_Just_TryingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuma mau coba-coba dulu`)
};

/**
* | output |
* | --- |
* | "Just wanted to try it" |
*
* @param {Settings_Cancel_Reason_Just_TryingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_cancel_reason_just_trying = /** @type {((inputs?: Settings_Cancel_Reason_Just_TryingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Cancel_Reason_Just_TryingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_cancel_reason_just_trying(inputs)
	return en_settings_cancel_reason_just_trying(inputs)
});